import Icon from '@components/v2/ui/Icon/Icon';
import { Box, CircularProgress, InputAdornment } from '@mui/material';
import { Check, CircleAlert } from 'lucide-react';
import ErrorTooltip from './ErrorTooltip';
import useWidth from './Hooks/useWidth';

export type StatusAdornmentStatus = 'loading' | 'error' | 'success' | 'unset';

type StatusAdornmentProps = {
  status: StatusAdornmentStatus;
  errorMessage: string;
  withTooltip?: boolean;
};

const StatusAdornment = ({ status, errorMessage, withTooltip }: StatusAdornmentProps) => {
  const { mobileWidth } = useWidth();

  const renderAdornment = () => {
    if (status === 'loading') {
      return <CircularProgress size={mobileWidth ? 16 : 18} />;
    }

    if (status === 'error') {
      return withTooltip ? (
        <ErrorTooltip errorMessage={errorMessage} />
      ) : (
        <Box component="span" sx={{ display: 'inline-flex', color: 'error.main' }}>
          <Icon icon={CircleAlert} size="lg" />
        </Box>
      );
    }

    if (status === 'success') {
      return (
        <Box component="span" sx={{ display: 'inline-flex', color: 'accent.dark' }}>
          <Icon icon={Check} size={mobileWidth ? 'md' : 'lg'} />
        </Box>
      );
    }

    return null;
  };

  return <InputAdornment position="end">{renderAdornment()}</InputAdornment>;
};

export default StatusAdornment;
